import { useEffect } from 'react';

export function useIdleGlitch(controls) {
  useEffect(() => {
    let timeoutId;
    const scheduleGlitch = () => {
      const delay = 6000 + Math.random() * 5000;
      timeoutId = setTimeout(async () => {
        await controls.start({
          filter: ['brightness(1)', 'brightness(1.35)', 'brightness(0.92)', 'brightness(1)'],
          rotate: [0, -1.2, 0.8, 0],
          transition: { duration: 0.2, times: [0, 0.35, 0.7, 1] },
        });
        scheduleGlitch();
      }, delay);
    };
    scheduleGlitch();
    return () => clearTimeout(timeoutId);
  }, [controls]);
}
